import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleConditionSubSection() {
  return (
    <VFKit.SubSection data-testid="vehicle-condition">
      <VFKit.ConditionChips />
    </VFKit.SubSection>
  );
}
